import CausalEditor from './CausalEditor.svelte';
export default CausalEditor;
